// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"91f17ab0","453":"05f8c4a7"}[chunkId] + ".chunk.js";
};